import { Injectable } from '@angular/core';
import { LocalStorageKeys, Permission, UserSession } from '@models/index.model';
import { UtilsService } from '@services/index.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private _utils: UtilsService) {}

  public setPermissionsToLocalStorage(userPermissions: Permission[]) {
    let userSession: UserSession = this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession;
    if (!!userSession) {
      userSession['userPermissions'] = userPermissions;
      this._utils.setLocalStorage(LocalStorageKeys.SESSION_KEY, userSession);
    }
  }

  public getPermissionsFromLocalStorage(): Permission[] {
    return (this._utils.getLocalStorage(LocalStorageKeys.SESSION_KEY) as UserSession)?.userPermissions;
  }

  public hasPermiss(permissToCheck: Permission): boolean {
    const userPermissions: Permission[] = this.getPermissionsFromLocalStorage();
    if (!!userPermissions) {
      return userPermissions.includes(permissToCheck);
    }
    return false;
  }

  public hasAllPermiss(...permissToCheck: Permission[]): boolean {
    return permissToCheck && permissToCheck.every(permissWanted => this.hasPermiss(permissWanted));
  }

  public hasAnyPermiss(...permissToCheck: Permission[]): boolean {
    return permissToCheck && permissToCheck.some(permissWanted => this.hasPermiss(permissWanted));
  }
}
